import "core-js/modules/es.array.map.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { editFormItems, addFormItems, rules } from './config';
import { demoRemove, DEMO_PAGE_URL, DOME_BASE_URL, exportExcel, IMPORT_URL } from '@/api/demo/demo';
import { tableAddHeader, tableDeleteHeader, tableEditHeader, tableImportHeader, tableExportHeader } from '@/component-create/utils/create-table-column';
import ExpForm from '@/components/exp-form-container/ExpForm.vue';
import { formatter as _formatter, isOnlyOne } from '@/utils/common';
import { USER_GENDER, USER_STATUS } from '@/constant/system/code';
import { Edit, Delete } from '@element-plus/icons-vue';
import { deleteBox, toast, warningBox } from '@/utils/message';
import { XDataImport, XTable } from '@/components/index';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Demo',
  setup: function setup(__props) {
    var searchForm = ref({
      username: '',
      phoneNumber: '',
      status: ''
    });
    var tableInstance = ref();
    var editFormInstance = ref();
    var addFormInstance = ref();
    var dateImportInstance = ref();
    var searchData = {};
    var headerButton = [tableAddHeader(function () {
      var _addFormInstance$valu;
      (_addFormInstance$valu = addFormInstance.value) === null || _addFormInstance$valu === void 0 || _addFormInstance$valu.open();
    }), tableEditHeader(function (rows) {
      if (isOnlyOne(rows)) {
        var _editFormInstance$val;
        (_editFormInstance$val = editFormInstance.value) === null || _editFormInstance$val === void 0 || _editFormInstance$val.open(rows[0].id);
      }
    }), tableDeleteHeader(function (rows) {
      if (rows.length === 0) {
        toast.warn('请至少选择一条数据');
        return;
      }
      deleteBox().then(function () {
        demoRemove(rows.map(function (i) {
          return i.id;
        })).then(function () {
          var _tableInstance$value;
          toast.success('删除成功');
          (_tableInstance$value = tableInstance.value) === null || _tableInstance$value === void 0 || _tableInstance$value.load(searchData);
        });
      });
    }), tableImportHeader(function () {
      var _dateImportInstance$v;
      (_dateImportInstance$v = dateImportInstance.value) === null || _dateImportInstance$v === void 0 || _dateImportInstance$v.show();
    }), tableExportHeader(function () {
      warningBox('是否确认导出数据？').then(function () {
        exportExcel(searchData);
      });
    })];
    function search(formData) {
      var _tableInstance$value2;
      searchData = formData;
      (_tableInstance$value2 = tableInstance.value) === null || _tableInstance$value2 === void 0 || _tableInstance$value2.load(formData);
    }
    function reset() {
      var _tableInstance$value3;
      searchForm.value = {
        username: ''
      };
      (_tableInstance$value3 = tableInstance.value) === null || _tableInstance$value3 === void 0 || _tableInstance$value3.load({});
    }
    function handleUpdateItem(row) {
      var _editFormInstance$val2;
      (_editFormInstance$val2 = editFormInstance.value) === null || _editFormInstance$val2 === void 0 || _editFormInstance$val2.open(row.id);
    }
    function handleRemoveItem(row) {
      deleteBox().then(function () {
        demoRemove([row.id]).then(function () {
          toast.success('删除成功');
          tableReLoad();
        });
      });
    }
    function tableReLoad() {
      var _tableInstance$value4;
      (_tableInstance$value4 = tableInstance.value) === null || _tableInstance$value4 === void 0 || _tableInstance$value4.load(searchData);
    }
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_col = _resolveComponent("el-col");
      var _component_XSelect = _resolveComponent("XSelect");
      var _component_ElTableColumn = _resolveComponent("ElTableColumn");
      var _component_el_link = _resolveComponent("el-link");
      var _component_XFormDialog = _resolveComponent("XFormDialog");
      var _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(function () {
          return [_createVNode(ExpForm, {
            model: _unref(searchForm),
            "label-width": 80,
            onSearch: search,
            onReset: reset
          }, {
            default: _withCtx(function (_ref) {
              var colspan = _ref.colspan;
              return [_createVNode(_component_el_col, {
                span: colspan,
                class: "exp-item"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_form_item, {
                    prop: "username",
                    label: "用户名"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_input, {
                        modelValue: _unref(searchForm).username,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                          return _unref(searchForm).username = $event;
                        }),
                        placeholder: "请输入用户名"
                      }, null, 8, ["modelValue"])];
                    }),
                    _: 1
                  })];
                }),
                _: 2
              }, 1032, ["span"]), _createVNode(_component_el_col, {
                span: colspan,
                class: "exp-item"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_form_item, {
                    label: "手机号码"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_input, {
                        modelValue: _unref(searchForm).phoneNumber,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                          return _unref(searchForm).phoneNumber = $event;
                        }),
                        placeholder: "请输入手机号"
                      }, null, 8, ["modelValue"])];
                    }),
                    _: 1
                  })];
                }),
                _: 2
              }, 1032, ["span"]), _createVNode(_component_el_col, {
                span: colspan,
                class: "exp-item"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_form_item, {
                    label: "状态"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_XSelect, {
                        modelValue: _unref(searchForm).status,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                          return _unref(searchForm).status = $event;
                        }),
                        loader: "USER_STATUS",
                        allOption: true,
                        smartSearch: "",
                        placeholder: "请选择"
                      }, null, 8, ["modelValue"])];
                    }),
                    _: 1
                  })];
                }),
                _: 2
              }, 1032, ["span"])];
            }),
            _: 1
          }, 8, ["model"]), _createVNode(_unref(XTable), {
            ref_key: "tableInstance",
            ref: tableInstance,
            url: _unref(DEMO_PAGE_URL),
            "show-index": "",
            selectable: "",
            "header-buttons": headerButton,
            "el-table-props": {
              border: true
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_ElTableColumn, {
                label: "用户名",
                prop: "username",
                width: "200"
              }), _createVNode(_component_ElTableColumn, {
                label: "性别",
                prop: "gender",
                width: "60",
                align: "center",
                formatter: function formatter(row) {
                  return _unref(_formatter)(_unref(USER_GENDER), row.gender);
                }
              }, null, 8, ["formatter"]), _createVNode(_component_ElTableColumn, {
                label: "出生日期",
                prop: "birthday",
                width: "100",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "邮箱",
                prop: "email",
                width: "200"
              }), _createVNode(_component_ElTableColumn, {
                label: "手机号码",
                prop: "phoneNumber",
                width: "120",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "状态",
                prop: "status",
                width: "60",
                align: "center",
                formatter: function formatter(row) {
                  return _unref(_formatter)(_unref(USER_STATUS), row.gender);
                }
              }, null, 8, ["formatter"]), _createVNode(_component_ElTableColumn, {
                label: "备注",
                prop: "remark",
                "show-overflow-tooltip": ""
              }), _createVNode(_component_ElTableColumn, {
                label: "操作",
                width: "150",
                align: "center"
              }, {
                default: _withCtx(function (_ref2) {
                  var row = _ref2.row;
                  return [_createVNode(_component_el_link, {
                    underline: false,
                    icon: _unref(Edit),
                    type: "primary",
                    onClick: function onClick($event) {
                      return handleUpdateItem(row);
                    }
                  }, {
                    default: _withCtx(function () {
                      return _cache[3] || (_cache[3] = [_createElementVNode("span", {
                        style: {
                          "padding": "0 6px 0 4px"
                        }
                      }, "编辑", -1)]);
                    }),
                    _: 2
                  }, 1032, ["icon", "onClick"]), _createVNode(_component_el_link, {
                    underline: false,
                    icon: _unref(Delete),
                    type: "primary",
                    onClick: function onClick($event) {
                      return handleRemoveItem(row);
                    }
                  }, {
                    default: _withCtx(function () {
                      return _cache[4] || (_cache[4] = [_createElementVNode("span", {
                        style: {
                          "padding-left": "4px"
                        }
                      }, "删除", -1)]);
                    }),
                    _: 2
                  }, 1032, ["icon", "onClick"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["url"]), _createVNode(_component_XFormDialog, {
            ref_key: "editFormInstance",
            ref: editFormInstance,
            title: "编辑",
            form: {
              items: _unref(editFormItems),
              loadUrl: _unref(DOME_BASE_URL),
              saveUrl: _unref(DOME_BASE_URL),
              saveMethods: 'put',
              elFormProps: {
                rules: _unref(rules)
              }
            },
            onSaveSuccess: tableReLoad
          }, null, 8, ["form"]), _createVNode(_component_XFormDialog, {
            ref_key: "addFormInstance",
            ref: addFormInstance,
            title: "新增",
            form: {
              items: _unref(addFormItems),
              saveUrl: _unref(DOME_BASE_URL),
              elFormProps: {
                rules: _unref(rules)
              }
            },
            onSaveSuccess: tableReLoad
          }, null, 8, ["form"]), _createVNode(_unref(XDataImport), {
            ref_key: "dateImportInstance",
            ref: dateImportInstance,
            action: _unref(IMPORT_URL),
            templateUrl: "示例模板.xlsx",
            "export-base-url": "system/file"
          }, null, 8, ["action"])];
        }),
        _: 1
      });
    };
  }
});